import { useMutation } from 'react-query';
import { ToastContext } from 'app/components/Context/ToastContext';
import { useContext } from 'react';
import { PostUsersBotAction } from 'services/apiServices';
import {
  Errors,
  PostUsersBotActionParams,
  PostUsersBotActionResult,
} from 'types/ApiServicesTypes';

export default function usePostUsersBotAction(id: number) {
  const { showAlert } = useContext(ToastContext);
  const mutation = useMutation<
    PostUsersBotActionResult,
    Errors,
    PostUsersBotActionParams
  >(['PostUsersBotAction', id], values =>
    PostUsersBotAction(id, values)
      .then(res => {
        if (res.error) showAlert!(res.error);
        if (res.errors && res.errors.length)
          showAlert!(res.errors.join('<br/>'));

        return res;
      })
      .catch(err => {
        showAlert!(err.message as string);
        return err;
      }),
  );

  if (mutation.isError && mutation.error) {
    showAlert!(mutation.error.message);
  }

  return mutation;
}
